export default{
  namespaced:true,
  actions:{
    async getPlayAuth(context, params){//获取视频播放权限
      let {data}=await axios.get("media/api/video_play_auth", {params})
      return data
    },
  }
}
